import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { siteData } from "../mock";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cp_cookie_accepted");
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cp_cookie_accepted", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 rounded-xl bg-[#0b1220] shadow-2xl border border-white/10 p-4">
      <div className="flex items-start justify-between gap-3">
        <p className="text-sm text-white/80 leading-relaxed">
          {siteData.cookie.text}{" "}
          <a href="#privacy" className="underline text-blue-400">
            {siteData.cookie.linkLabel}
          </a>
        </p>
        <button onClick={() => setVisible(false)} aria-label="Close" className="text-white/60 hover:text-white">
          <X size={18} />
        </button>
      </div>
      <div className="mt-3 flex items-center justify-end gap-2">
        <button onClick={() => setVisible(false)} className="px-3 py-1.5 text-sm text-white/80 hover:bg-white/[0.06] rounded-md transition-colors">
          Settings
        </button>
        <button onClick={accept} className="px-4 py-1.5 text-sm rounded-md bg-blue-600 text-white hover:bg-blue-500 transition-colors">
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
